export const currenciesNo = {
  AED: 'Emiratarabisk dirham',
  AFN: 'Afghansk afghani',
  ALL: 'Albansk lek',
  AMD: 'Armensk dram',
  AOA: 'Angolansk kwanza',
  ARS: 'Argentinsk peso',
  AUD: 'Australsk dollar',
  AWG: 'Arubansk florin',
  AZN: 'Aserbajdsjansk manat',
  BAM: 'Konvertibilna mark',
  BBD: 'Barbadisk dollar',
  BDT: 'Bangladeshisk taka',
  BGN: 'Bulgarsk lev',
  BHD: 'Bahrainsk dinar',
  BIF: 'Burundisk franc',
  BMD: 'Bermudisk dollar',
  BND: 'Bruneisk dollar',
  BOB: 'Boliviansk boliviano',
  BRL: 'Brasiliansk real',
  BSD: 'Bahamansk dollar',
  BTN: 'Bhutansk ngultrum',
  BWP: 'Botswansk pula',
  BYR: 'Belarusisk rubel',
  BZD: 'Belizisk dollar',
  CAD: 'Kanadisk dollar',
  CDF: 'Kongolesisk franc',
  CHF: 'Sveitsisk franc',
  CLP: 'Chilensk peso',
  CNY: 'Kinesisk renminbi',
  COP: 'Kolombiansk peso',
  CRC: 'Kostarikansk colón',
  CUC: 'Kubansk konvertibel peso',
  CUP: 'Kubansk peso',
  CVE: 'Kappverdisk escudo',
  CZK: 'Tsjekkisk koruna',
  DJF: 'Djiboutisk franc',
  DKK: 'Dansk krone',
  DOP: 'Dominikansk peso',
  DZD: 'Algerisk dinar',
  EGP: 'Egyptisk pund',
  EUR: 'Euro',
  ERN: 'Eritreisk nakfa',
  ETB: 'Etiopisk birr',
  FJD: 'Fijiansk dollar',
  FKP: 'Falklandspund',
  GBP: 'Britisk pund',
  GEL: 'Georgisk lari',
  GHS: 'Ghanesisk cedi',
  GIP: 'Gibraltarsk pund',
  GMD: 'Gambisk dalasi',
  GNF: 'Guineansk franc',
  GTQ: 'Guatemalansk quetzal',
  GYD: 'Guyansk dollar',
  HKD: 'Hongkongdollar',
  HNL: 'Honduransk lempira',
  HRK: 'Kroatisk kuna',
  HTG: 'Haitisk gourde',
  HUF: 'Ungarsk forint',
  IDR: 'Indonesisk rupiah',
  ILS: 'Ny israelsk shekel',
  INR: 'Indisk rupi',
  IQD: 'Irakisk dinar',
  IRR: 'Iransk rial',
  ISK: 'Islandsk krone',
  JMD: 'Jamaikansk dollar',
  JOD: 'Jordansk dinar',
  JPY: 'Japansk yen',
  KES: 'Kenyansk shilling',
  KGS: 'Kirgisisk som',
  KHR: 'Kambodsjansk riel',
  KMF: 'Komorisk franc',
  KPW: 'Nordkoreansk won',
  KRW: 'Sørkoreansk won',
  KWD: 'Kuwaitisk dinar',
  KYD: 'Caymansk dollar',
  KZT: 'Kasakhstansk tenge',
  LAK: 'Laotisk kip',
  LBP: 'Libanesisk pund',
  LKR: 'Srilankisk rupi',
  LRD: 'Liberisk dollar',
  LSL: 'Lesothisk loti',
  LYD: 'Libysk dinar',
  MAD: 'Marokkansk dirham',
  MDL: 'Moldovsk leu',
  MGA: 'Madagassisk ariary',
  MKD: 'Makedonsk denar',
  MMK: 'Burmesisk kyat',
  MNT: 'Mongolsk togrog',
  MOP: 'Macaoisk pataca',
  MRO: 'Mauritansk ouguiya',
  MUR: 'Mauritisk rupi',
  MVR: 'Maldivisk rufiyah',
  MWK: 'Malawisk kwacha',
  MXN: 'Meksikansk peso',
  MYR: 'Malaysisk ringgit',
  MZN: 'Mosambikisk metical',
  NAD: 'Namibisk dollar',
  NGN: 'Nigeriansk naira',
  NIO: 'Nicaraguansk córdoba',
  NOK: 'Norsk krone',
  NPR: 'Nepalsk rupi',
  NZD: 'Nyzealandsk dollar',
  OMR: 'Omansk rial',
  PAB: 'Panamansk balboa',
  PEN: 'Peruansk nuevo sol',
  PGK: 'Papuansk kina',
  PHP: 'Filippinsk peso',
  PKR: 'Pakistansk rupi',
  PLN: 'Polsk złoty',
  PYG: 'Paraguayansk guaraní',
  QAR: 'Qatarsk rijal',
  RON: 'Rumensk leu',
  RSD: 'Serbisk dinar',
  RUB: 'Russisk rubel',
  RWF: 'Rwandisk franc',
  SAR: 'Saudiarabisk rijal',
  SBD: 'Salomonsk dollar',
  SCR: 'Seychelliansk rupi',
  SDG: 'Sudansk pund',
  SEK: 'Svensk krone',
  SGD: 'Singaporsk dollar',
  SHP: 'Sankthelensk pund',
  SLL: 'Sierraleonsk leone',
  SOS: 'Somalisk shilling',
  SRD: 'Surinamsk dollar',
  SSP: 'Sørsudansk pund',
  STD: 'Saotomesisk dobra',
  SYP: 'Syrisk pund',
  SZL: 'Eswatinisk lilangeni',
  THB: 'Thailandsk baht',
  TJS: 'Tadsjikisk somoni',
  TMM: 'Turkmensk manat',
  TND: 'Tunisisk dinar',
  TOP: 'Tongansk paanga',
  TRY: 'Tyrkisk lira',
  TTD: 'Trinidadisk dollar',
  TWD: 'Taiwansk dollar',
  TZS: 'Tanzaniansk shilling',
  UAH: 'Ukrainsk hryvnia',
  UGX: 'Ugandisk shilling',
  USD: 'Amerikansk dollar',
  UYU: 'Uruguayansk peso',
  UZS: 'Usbekisk som',
  VEF: 'Venezuelansk bolívar',
  VND: 'Vietnamesisk dong',
  VUV: 'Vanuatisk vatu',
  WST: 'Samoansk tala',
  YER: 'Jemenittisk rial',
  ZAR: 'Sørafrikansk rand',
  ZMW: 'Zambisk kwacha',
  ZWL: 'Zimbabwisk dollar',
  ANG: 'Antillansk gylden',
} as const;
